export default __webpack_public_path__ + "static/O0018-4ec9499031bc163d45dcc5c0047c2707.png";